export const styles = {
  arrow: {
    width: '0.875rem',
    height: 'auto',
    mx: 1,
  },
};
